module.exports = __webpack_public_path__ + "img/kaifashang_bg.cdd74696.png";